import {Component, HostListener, Inject} from "@angular/core";
import {
  Staff, StaffAttendanceControllerService,
  StaffAttendanceReq,
  StaffProfileControllerService
} from "../../../@services/gen";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {LocalstorageService} from "../../../@services/localstorage.service";
import {NotificationService} from "../../../@services/notification.service";
import {TdDialogService} from "@covalent/core/dialogs";
import {StaffEditorDialogComponent} from "../staff-editor-dialog/staff-editor-dialog.component";
import {NfcScanDialogComponent} from "../../../@components/nfc-scan-dialog/nfc-scan-dialog.component";
import {take} from "rxjs";

@Component({
  selector: "app-staff-search-dialog",
  templateUrl: "./staff-search-dialog.component.html",
  styleUrls: ["./staff-search-dialog.component.scss"]
})
export class StaffSearchDialogComponent {
  staff: Staff;
  staffAttendance: StaffAttendanceReq = {};
  title: string = "Search Staff or Scan NFC Card";
  loading: boolean;
  keyword: string = '';
  isMobile: boolean = false;
  nfcSupported: boolean = false;

  constructor(private dialogRef: MatDialogRef<StaffSearchDialogComponent>,
              private ds: TdDialogService,
              private ns: NotificationService,
              private ls: LocalstorageService,
              private staffService: StaffProfileControllerService,
              private staffAttendanceService: StaffAttendanceControllerService,
              @Inject(MAT_DIALOG_DATA) private data: any
              ) {
    this.checkIsMobile();
    this.nfcSupported = typeof (window as any).ReactNativeWebView !== 'undefined';
  }

  scanNFC() {
    this.ds
      .open(NfcScanDialogComponent, {
        disableClose: true,
        minWidth: '350px'
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.keyword = result.uid;
          this.searchAndAutoSubmit();
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkIsMobile();
  }

  private checkIsMobile() {
    this.isMobile = window.innerWidth < 768; // You can adjust the threshold as needed
  }

  search(event?) {
    if(event){
      event.preventDefault();
    }

    this.loading = true;
    this.staffService
      .getPagedStaffProfilePost({
        merchantId: this.ls.getMerchant().id,
        search: this.keyword,
      })
      .subscribe(
        (res) => {
          if (res.content && res.content.length > 0) {
            this.staff = res.content[0];
          } else {
            if (this.staff) {
              this.staff = null;
            }

            this.ds
              .openConfirm({
                title: 'Invalid Staff ID',
                message: 'Add New Staff?',
              })
              .afterClosed()
              .subscribe((confirmed) => {
                if (confirmed) {
                  this.addStaff();
                }
              });
          }
        },
        (error) => {
          this.ns.showNotification({message: 'Staff not found'});
          this.loading = false;
        }
      );
  }

  searchAndAutoSubmit() {
    this.loading = true;
    this.staffService
      .getPagedStaffProfilePost({
        merchantId: this.ls.getMerchant().id,
        search: this.keyword,
      })
      .subscribe(
        (res) => {
          if (res.content && res.content.length > 0) {
            this.staff = res.content[0];
            this.submit();
          } else {
            this.ns.showNotification({message: 'Staff not found'});
            this.loading = false;
          }
        },
        (error) => {
          this.ns.showNotification({message: 'Staff not found'});
          this.loading = false;
        }
      );
  }

  addStaff() {
    let minHeight = null;
    let minWidth = '50%';

    if (this.isMobile) {
      minHeight = '100vh';
      minWidth = '100vw';
    }

    this.ds
      .open(StaffEditorDialogComponent, {
        minHeight: minHeight,
        minWidth: minWidth,
        data: {
          staff: {staffNo: this.keyword},
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((staff) => {
        if (staff) {
          this.staff = staff;
          this.submit();
        }
      });
  }

  addStaffAttendance() {
    this.staffAttendanceService.upsertStaffAttendancePost({
      staffAttendance: {...this.staffAttendance, staff: {id : this.staff.id }, merchant: {id: this.ls.getMerchant().id}},
    }).subscribe
    (
      (attendance) => {
        this.ns.showNotification({message: 'Successfully add new record!'});
        this.loading = false;
        this.dialogRef.close(attendance);
      },
      (error) => {
        this.ns.showNotification({message: 'Record is already exist!'});
        this.loading = false;
      }
    );
  }

  submit() {
    this.dialogRef.close(this.staff);
    this.addStaffAttendance();
  }
}
